export default __webpack_public_path__ + "static/media/dot_orange.c0eb03a4.png";